import { useEffect } from 'react';

import { useMenuState } from '@szhsin/react-menu';
import { useTranslation } from 'react-i18next';

import { CHART_TABS } from 'constants/enums';
import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { useChartTabs } from 'hooks/useChartTabs';
import { selectedProductSelector } from 'selectors/tradeSelectors';
import { useAppSelector } from 'storeHooks';
import FilterDropDown from 'UIKit/FilterDropDown';

import classes from './chartTypeDropdownStyles.module.scss';

const ChartTypeDropdown = () => {
  const { t } = useTranslation(['trading']);
  const [menuState, toggleMenu] = useMenuState();
  const { filteredTabs, activeTab } = useChartTabs();
  const selectedProduct = useAppSelector(selectedProductSelector);

  const chartTabOptions = {
    [CHART_TABS.PRICE_CHART]: t('trading:charts.priceChart'),
    [CHART_TABS.MARK_CHART]: t('trading:charts.markChart'),
    [CHART_TABS.FUNDING_CHART]: t('trading:charts.fundChart'),
    [CHART_TABS.DEPTH_CHART]: t('trading:charts.depthChart'),
    [CHART_TABS.INDEX_PRICE_CHART]: t('trading:charts.underlyingChart', {
      underlyingSymbol: selectedProduct?.underlying_asset?.symbol,
    }),
  };

  useEffect(() => {
    if (menuState.state === 'open') {
      trackMixpanelEvent(MIXPANEL_EVENT_NAMES.CHART_TYPE.DROPDOWN_CLICKED, {
        current: activeTab,
      });
    }
  }, [menuState, activeTab]);

  return (
    <FilterDropDown
      testId="chart-type-dropdown"
      menuState={menuState}
      toggleMenu={toggleMenu}
      label={chartTabOptions[activeTab]}
      options={filteredTabs}
      closeOnSelect
      styleOverrideClasses={{
        button: classes.dropdownButton,
        labelSection: classes.dropdownLabelSection,
        label: classes.dropdownLabel,
        dropdownOption: classes.dropdownOption,
        dropDown: classes.dropdown,
        optionLabel: classes.dropdownOptionLabel,
        active: classes.active,
        menu: classes.dropdownMenu,
      }}
    />
  );
};

export default ChartTypeDropdown;
